<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang].title : ''" type="gray">
        <template v-slot:body>
            <div class="flex w-full flex-column gap-3">
                
                <div class="w-full flex" :class="(screenSize=='xs' || isPWA || isTgApp) ? 'overflow-scroll' : ''">
                    <SelectButton v-model="index" :options="tags" optionLabel="label" optionValue="index"  dataKey="title" size="small">
                        <template #option="slotProps">
                            <span class="text-sm py-1 white-space-nowrap">{{ slotProps.option.label[lang] }}</span>
                        </template>
                    </SelectButton>
                </div>

                <Faq :tabs="filteredTabs"/>

            </div>
        </template>
    </Page>
</template>


<script>
import faq_json from '@/assets/json/faq.json'
import Faq from '@/components/widgets/FaqList.vue'
import Page     from '@/components/sides/Page.vue' 
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            tabs: [], 
            filteredTabs: [],
            header: {
                en:{
                    title: "FAQ",
                },
                ru:{
                    title: "Вопрос-ответ",
                }
            },
            buttons:  {
                en:{
                    main : "Main",
                    transfer: "Create a transfer",
                },
                ru:{
                    main : "На главную",
                    transfer: "Создать перевод",
                }
            }, 
            index: 0,
            tags: [
                {
                    label: {
                        ru: 'Все',
                        en: 'All'
                    },
                    index: 0,
                    code: null
                },
                {
                    label: {
                        ru: 'О сервисе',
                        en: 'About'
                    },
                    index: 1,
                    code: 'about'
                },
                {
                    label: {
                        ru: 'Переводы',
                        en: 'Transfers'
                    },
                    index: 2,
                    code: 'transfer'
                },
                {
                    label: {
                        ru: 'Карты',
                        en: 'Cards'
                    },
                    index: 3,
                    code: 'vcard'
                },
            ]
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    components: {
        Faq,
        Page
    },
    watch: {
        index(newIndex) {
            if (newIndex === 0) this.filteredTabs = this.tabs
            else this.filteredTabs = this.filterByTag(this.tags[newIndex].code)
        }
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        loadFaq() {
            this.tabs = faq_json
            this.filteredTabs = this.tabs
        },
        filterByTag(tag) {
            if (!tag) return this.tabs
            return this.tabs.filter(tab => {
                return tab.tags && tab.tags.includes(tag)
            })
        }
    },
    mounted() {
        try{ this.loadFaq() } catch (e){}

        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>